export default {
  state: {
    progress: false,
    status_modal: false,
    confirm_modal: false,
    comments_modal: false,
    edit_goal_modal: false,
    upload_file_modal: false,
    add_project_modal: false,
    add_customer_modal: false,
    mark_as_sent_modal: false,
    send_contract_modal: false,
    send_quotation_modal: false,
    add_obligations_modal: false,
    forgot_password_modal: false,
    review_contract_modal: false,
    assign_quotation_modal: false,
    edit_editor_text_modal: false,
    send_presentation_modal: false,
    pending_quotation_modal: false,
    add_variation_type_modal: false,
    approved_quotation_modal: false,
    change_quotation_priority: false,
    send_whats_quotation_modal: false,
    clone_quotation_model_modal: false,
    send_whats_presentation_modal: false,
    approved_admin_quotation_modal: false,
    add_variation_type_option_modal: false,
    payment_approved_quotation_modal: false,
  },
  mutations: {
    toggle(state, toggleType) {
      state[toggleType] = !state[toggleType];
    },
    setToggle(state, data) {
      state[data.type] = data.bool;
    },
  },
  actions: {
    toggle({ commit }, toggleType) {
      commit('toggle', toggleType);
    },
    setToggle({ commit }, data) {
      commit('setToggle', data);
    },
  },
};
